import React from "react";
import { Tooltip } from "@mui/material";

const TOOLTIP_SLOT_PROPS = {
    tooltip: {
        sx: { maxWidth: 300, fontSize: "12px", lineHeight: 1.45 },
    },
};

interface AnalyticsTooltipProps {
    title: string;
    children: React.ReactElement;
}

/** Wraps analytics UI with a hover tooltip — no info icon, keeps the layout light. */
const AnalyticsTooltip: React.FC<AnalyticsTooltipProps> = ({ title, children }) => (
    <Tooltip title={title} arrow placement="top" enterTouchDelay={0} slotProps={TOOLTIP_SLOT_PROPS}>
        {children}
    </Tooltip>
);

export default AnalyticsTooltip;
